import React from 'react';
import { PenTool } from 'lucide-react';

const ManualBadgeNotice = ({ judges = [] }) => {
  return (
    <div className='mt-6'>
      <div className='bg-yellow-50 border border-yellow-200 p-6 rounded-lg'>
        <div className='flex items-start space-x-3'>
          <div className='flex-shrink-0'>
            <PenTool className='h-6 text-yellow-600 w-6' />
          </div>
          <div className='flex-1'>
            <h3 className='font-semibold text-lg text-yellow-800'>
              Manual Badge Notice
            </h3>
            <p className='mt-2 text-yellow-700'>
              These judges do not have a pre-printed badge but should have a
              manually written badge.
            </p>

            <div className='mt-4'>
              <ul className='space-y-2'>
                {judges.map((judge, index) => (
                  <li
                    key={index}
                    className='bg-white border border-yellow-200 px-3 py-2 rounded-md'>
                    <span className='text-gray-800'>{judge}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ManualBadgeNotice;
